export interface WizardStep {
  path: string;
  label: string;
}

export const WIZARD_STEPS: readonly WizardStep[] = [
  { path: '/audience-builder', label: 'Target' },
  { path: '/audience-products', label: 'Products' },
  { path: '/audience-content', label: 'Content' },
  { path: '/audience-review', label: 'Review' },
] as const;

/** The one step the flow can drop — see `useWizardSteps` (NPJB-517). */
export const CONTENT_STEP_PATH = '/audience-content';

export const buildStepPath = (stepPath: string, id?: string | null): string =>
  id ? `${stepPath}/${id}` : stepPath;

/** A step owns the pathname when it matches exactly or is its `/:id` parent. */
export const matchesStepPath = (pathname: string, stepPath: string): boolean =>
  pathname === stepPath || pathname.startsWith(`${stepPath}/`);

/**
 * Index of the current step within a step list. Pass the *effective* list from
 * `useWizardSteps` when the answer drives navigation (NPJB-517) — against the
 * full `WIZARD_STEPS` a skipped Content step would still be walked into.
 */
export const stepIndexFromPathname = (
  pathname: string,
  steps: readonly WizardStep[] = WIZARD_STEPS,
): number => {
  for (let i = 0; i < steps.length; i++) {
    if (matchesStepPath(pathname, steps[i].path)) {
      return i;
    }
  }
  return -1;
};
